export const roles_placeholders = [
    {
        name: 'President',
    },
];

export const roles_placeholders_len = roles_placeholders.length;